import React from "react";
import Information from "../Information";
import Store from "../../../content/Store";
import Content from "../../../content/Content";
import ErrorContentLinks from "./sharedErrorContent/ErrorContentLinks";

export const RestrictedGroup = () => {
  return (
    <Information headerText={Store.ErrorPages.RestrictedGroup.HeaderText}>
      <Content name={Store.ErrorPages.RestrictedGroup.Message} />
      <ErrorContentLinks />
    </Information>
  );
};
